import React from 'react'
import Text from '@embracesbs/component-text'
import Icon from '@embracesbs/component-icon'

// Centered spinner + label, matching the loading style used in the subscription list.
const LoadingState: React.FC<{ text: string }> = ({ text }) => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    }}
  >
    <Icon color='var(--tma-accent)' iconName='EmailActionSync1' size={24} style={{ animation: 'spin 1s linear infinite' }} />
    <Text textStyle='description' textColor='grey' content={text} />
  </div>
)

export default LoadingState
